import { render, staticRenderFns } from "./SliderSingle.vue?vue&type=template&id=297fbc42&scoped=true"
import script from "./SliderSingle.vue?vue&type=script&lang=js"
export * from "./SliderSingle.vue?vue&type=script&lang=js"
import style0 from "./SliderSingle.vue?vue&type=style&index=0&id=297fbc42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fbc42",
  null
  
)

export default component.exports